function _handleWindowSize(store) {
  if (store.state.Session.useIpadBrowserTargets) {
    return;
  }
  const markersAndTargetsEl = document.getElementById(
    "go_markers-targets-container"
  );
  if (!markersAndTargetsEl) {
    return;
  }

  if (
    window.innerWidth < markersAndTargetsEl.offsetWidth + 20 ||
    window.innerHeight < markersAndTargetsEl.offsetHeight + 55
  ) {
    store.state.Resolution.canMarkersTargetsFit = false;
  } else {
    store.state.Resolution.canMarkersTargetsFit = true;
  }
}

function set(store = null) {
  window.onresize = () => {
    store.dispatch("Resolution/checkResolution");
    _handleWindowSize(store);
  };
}

function check(store) {
  _handleWindowSize(store);
}

export default { check, set };
